module.exports = __webpack_public_path__ + "static/media/foodprint_app3_preview.afaf1ba1.jpg";